import { Component, OnInit, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '../../../node_modules/@angular/router';
import { ModalService } from '../common/services/modal.service';
import { HttpClient } from '@angular/common/http';
import { Slide } from '../carousel/carousel.interface';
import { AnimationType } from '../carousel/carousel.animations';
import { CarouselComponent } from '../carousel/carousel.component';
import { CacheService } from '../common/services/cache.service';

@Component({
    selector: 'app-revised-original-landing-page',
    templateUrl: './revised-original-landing-page.component.html',
    styleUrls: ['./revised-original-landing-page.component.scss'],
    standalone: false
})
export class RevisedOriginalLandingPageComponent implements OnInit {
  @ViewChild(CarouselComponent) carousel!: CarouselComponent;
  currentSlide = 0;
  animationType = AnimationType.Slide;
imgabout = "/assets/img/blog/card_display_2023.webp";
resentpost = "https://widget.taggbox.com/76864";
// article = "/assets/img/blog/card-display1.webp";
// download = "/assets/img/blog/card-display1.webp";
// readmore = "/assets/img/blog/card-display1.webp";

// imgabout = "/assets/img/blog/card_display_2023.png";
// imgabout = 'data:image/jpeg;base64,' + aboutBase64;

article = "/assets/img/blog/Dolphins_Article.webp";
// article = 'data:image/jpeg;base64,' + articleBase64;
download = "/assets/img/blog/MobileAppArticle.webp";
// download = 'data:image/jpeg;base64,' + downloadBase64;
// readmore = 'data:image/jpeg;base64,' + readMoreBase64;
// readmore = "/assets/img/blog/no-upcharge-modern.webp";
readmore = "/assets/img/blog/SGC_Joins_Collectors.jpg";
  instaFeed: any;
  animationTypes = [
    {
      name: 'Slide',
      value: AnimationType.Slide,
    },
    // {
    //   name: "Flip",
    //   value: AnimationType.Flip
    // },
    // {
    //   name: "Jack In The Box",
    //   value: AnimationType.JackInTheBox
    // }
  ];
  sliderShow!: Slide[];

  slides: Slide[] = [
    // {
    //   type: 'img',
    //   headline: "$15 Grading",
    //   src: "/assets/img/carousel/03_2025 New Banner.png"
    // },
    {
      type: 'img',
      headline: "Updated Mailing Address",
      src: "/assets/img/carousel/Updated_Mailing_Address_FINAL.jpg"
    },
    {
      type: 'img',
      headline: "$15 Grading",
      src: "/assets/img/carousel/New_Banner_August_2025.jpg"
    },
    // {
    //   type: 'img',
    //   headline: "2024 Topps Chrome Update Special",
    //   src: "/assets/img/carousel/2024 Topps Chrome Update Web Banner Final.png"
    // },
    // {
    //   type: 'img',
    //   headline: "Topps Now Grading Special",
    //   src: "/assets/img/carousel/Topps Now Banner.png"
    // },
    {
      type: 'img',
      headline: "Take Your Collection With You",
      link: "/sgc-grading-app",
      src: "/assets/img/carousel/Take Your Collection With You Banner.jpg"
    },
];
  constructor(
    public router: Router,
    private cacheService: CacheService,
    private modalService: ModalService,
    //private PopReportsService: PopReportsService,
    private metaService: Meta,
    private titleService: Title,
    private http: HttpClient
  ) {}

  ngOnInit() {
    //this.PopReportsService.checkInstgramFeed().subscribe(response => {
    //    this.instaFeed = response;
    //    console.log(this.instaFeed);
    //});
  //   
  //  this.cacheService.set('slide',this.slides);
  //  if(this.cacheService.get('slide')) {
  //   this.sliderShow = this.cacheService.get('slide')!;
  //   console.log(this.sliderShow);
  //  }



    this.titleService.setTitle('SGC Grading');
    // this.getInstaAccessToken();
    this.metaService.addTag({
      name: 'description',
      content:
        // 'SGC is the most trusted name in card grading and autograph authentication. Submit your cards and memorabilia today to build your collectionâ€™s value.',
        'SGC has been a trusted leader in the authentication and grading of trading cards for over 25 years. Visit gosgc.com to start your submission today!',
    });
  }

  ngOnDestroy() {
    this.metaService.removeTag("name='description'");
  }

  startSubmission() {
    this.router.navigate(['/checkout']);
  }

  setAnimationType(type: any) {
    this.animationType = type.value;
    setTimeout(() => {
      this.carousel.onNextClick();
    });
  }

  onPreviousClick() {
    const previous = this.currentSlide - 1;
    this.currentSlide = previous < 0 ? this.slides.length - 1 : previous;
    console.log('previous clicked, new current slide is: ', this.currentSlide);
  }

  onNextClick() {
    const next = this.currentSlide + 1;
    this.currentSlide = next === this.slides.length ? 0 : next;
    console.log('next clicked, new current slide is: ', this.currentSlide);
  }

  goToLegacyRegistry() {
    var options = {
      message: `Our brand new SGC Registry is coming soon!

        In the meantime, if you wish to use our current registry, please click on "Go to Legacy Registry" and you will be redirected to the old site.`,
      actionLabel: 'Go To Legacy Registry',
      actionCallback: () =>
        window.open('https://sgclegacy.com/registrymain.aspx', '_blank'),
    };

    this.modalService.open('feature-coming-soon', options);
  }

  goToLegacyPopulationReport() {
    var options = {
      message: `Our brand new SGC Population Report is coming soon!

        In the meantime, if you wish to use our current Population Report, please click on "Go to Legacy Pop Report" and you will be redirected to the old site.`,
      actionLabel: 'Go To Legacy Pop Report',
      actionCallback: () =>
        window.open('https://sgclegacy.com/PopulationReport.aspx', '_blank'),
    };

    this.modalService.open('feature-coming-soon', options);
  }

  goToLegacyVerification() {
    var options = {
      message: `Our brand new SGC Item Verification is coming soon!

        In the meantime, if you wish to use our current auto verification, please click on "Go to Legacy Verification" and you will be redirected to the old site.`,
      actionLabel: 'Go To Legacy Verification',
      actionCallback: () =>
        window.open('https://sgclegacy.com/AutoCertLookup.aspx', '_blank'),
    };

    this.modalService.open('feature-coming-soon', options);
  }
}
